module.exports = __webpack_public_path__ + "static/media/Buren.3d427709.mp3";